import { initialState, SettingState } from './setting.state'
import { createReducer, on, ActionReducer, Action } from '@ngrx/store'
import { InjectionToken } from '@angular/core'
import * as SettingActions from './setting.actions'

export const settingReducer = createReducer(
  initialState,
  on(SettingActions.settingRetrieved, (state, action) => {
    return {
      ...state,
      settings: state.settings.find((setting) => setting.name === action.setting.name)
        ? state.settings
        : state.settings.concat(action.setting)
    }
  }),
  on(SettingActions.settingModified, (state, action) => {
    return {
      ...state,
      settings: state.settings.filter((setting) => setting.name !== action.name)
    }
  })
)

export function publicSettingReducer(state: SettingState, action: Action) {
  return settingReducer(state, action)
}

export const SETTING_REDUCER = new InjectionToken<ActionReducer<SettingState>>('Setting Reducer')
